import { getSettings } from './settings';

/**
 * Verifica si un módulo debe estar visible para el cliente actual
 * @param {string} moduleName - Nombre del módulo (ej: 'aggregator', 'terminals')
 * @returns {boolean} - true si el módulo debe ser visible
 */
export function isModuleVisible(moduleName) {
  const hiddenModules = getSettings('modules.visibility.hiddenModules', []);
  return !hiddenModules.includes(moduleName);
}

/**
 * Obtiene los IDs de agregadores permitidos para el cliente actual
 * @returns {number[]|null} - Array de IDs permitidos, o null si todos están permitidos
 */
export function getAllowedAggregators() {
  const allowed = getSettings('modules.visibility.allowedAggregators', null);

  // Si no está definido o es array vacío, permitir todos
  if (!allowed || (Array.isArray(allowed) && allowed.length === 0)) {
    return null; // null = sin filtro, mostrar todos
  }

  return allowed;
}

/**
 * Filtra una lista de agregadores según los permitidos para el cliente
 * @param {Array} aggregators - Lista de agregadores {id, name, ...}
 * @returns {Array} - Lista filtrada
 */
export function filterAllowedAggregators(aggregators) {
  const allowed = getAllowedAggregators();

  // Si no hay restricción, retornar todos
  if (allowed === null) {
    return aggregators;
  }

  // Filtrar solo los IDs permitidos
  return aggregators.filter(agg => allowed.includes(agg.id));
}

// Marcas con sección de Punto de venta: solo pinpeo (1), igual que Agregadores.
// Se identifican por el owner de la marca y no por el dominio porque cada una
// tiene varios (panel, admin, cloudfront, localhost) y así no hay que tocar un
// json por dominio.
//
// Antes estaban también Trinexus (67) y Atmosphere/ATM (68). Si alguna vuelve a
// necesitarlo, NO hace falta tocar esta lista: basta con `features.pos: true` en
// el json de su dominio (ver abajo).
const POS_OWNERS = [1];

/**
 * ¿Esta marca tiene la sección de Punto de venta?
 *
 * El json de la marca puede forzar el valor con
 * `modules.visibility.features.pos` (para una marca nueva, o para apagarlo sin
 * tocar código); si no lo trae, manda la lista de owners.
 *
 * @returns {boolean}
 */
export function isPosEnabled() {
  const flag = getSettings('modules.visibility.features.pos', null);

  if (flag !== null) {
    return Boolean(flag);
  }

  return POS_OWNERS.includes(Number(getSettings('company.owner')));
}

/**
 * Verifica si una feature específica está habilitada
 * @param {string} featureName - Nombre de la feature
 * @param {boolean} defaultValue - Valor por defecto si no está definida
 * @returns {boolean}
 */
export function isFeatureEnabled(featureName, defaultValue = true) {
  return getSettings(`modules.visibility.features.${featureName}`, defaultValue);
}
